import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStaffMemberDetails, getWorkspacePriceDetails, saveworkspaceUpsellModal } from "../../Redux/Actions";
import { RootState } from "../../Redux/Reducers";
import { useCountdownHook } from "../../Utils/countdownTimerHook";
import { makeStyles } from "@material-ui/core/styles";
import { useStyles } from "./style";
import { goToRoute } from "../../Utils/goToRoute";
import { initiateColorSwitch } from "./tools";
import { checkToShowBanner } from "../../Utils/checkToShowBanner";
import { DLP_BANNER_UPSELL_FEATURE_TYPE } from "../DomainSalesSearch/utils/constant";
import ThemeUpsellBanner from "./ThemeUpsellBanner";

const AppBanner = (): JSX.Element => {
  const dispatch = useDispatch();
  const [styleProps, setStyleProps] = useState({
    color1: "#2256FF",
    color2: "#5F84FF",
  });
  const [apiCalled, setApiCalled] = useState(false);

  const classes = useStyles();

  const useStylesAnimation = makeStyles({
    [`@keyframes bgcolorchange`]: {
      "0%": {
        backgroundColor: styleProps.color1,
      },
      "25%": {
        backgroundColor: styleProps.color2,
      },
      "50%": {
        backgroundColor: styleProps.color1,
      },
      "75%": {
        backgroundColor: styleProps.color2,
      },
      // "100%": {
      //   backgroundColor: styleProps.color1,
      // },
    },
    workspaceBannerBgAnimate: {
      animation: `$bgcolorchange 2s  infinite alternate linear`,
    },
  });

  const classAnimation = useStylesAnimation(styleProps);

  const { storeData, subscriptionDetails, workspaceUpsellModal, staffMemberData } = useSelector((state: RootState) => ({
    storeData: state.storeReducer.store,
    subscriptionDetails: state.themeReducer.subscriptionDetails,
    workspaceUpsellModal: state.workspaceReducer.workspaceUpsellModal,
    staffMemberData: state.staffManagementReducer.staffMemberData,
  }));

  const bannerData = staffMemberData?.banner_info;
  const action = bannerData?.action;
  const bgColors = bannerData?.bg_colors;
  const expiryTime = bannerData?.expiry_time;

  const [hour, minute, second, timeDifference] = useCountdownHook(expiryTime);

  /** This ensures that once the timer is expired, we call getStaffMemberDetails once to update the banner details thereby removing the timer strip. Currently it gets stuck with 00:00:00 time */
  useEffect(() => {
    if (timeDifference <= 0 && !apiCalled) {
      // Call the API and set the state to prevent further calls
      dispatch(getStaffMemberDetails({ phone: storeData?.display_phone, storeId: storeData?.store_id }));
      setApiCalled(true);
    }
  }, [hour, minute, second, apiCalled]);

  const setBannerColor = () => {
    const minutes = parseInt(minute);
    initiateColorSwitch(
      (color1, color2) => {
        setStyleProps({ color1, color2 });
      },
      bgColors,
      minutes,
    );
  };

  useEffect(() => {
    if (bgColors) {
      setBannerColor();
    }
  }, [minute, bgColors]);

  if (!checkToShowBanner()) {
    return null;
  }

  const onBannerClick = () => {
    // For Domain Expiry isDomainBannerActive()
    // For Subscription Expiry isSubscriptionExpiring()
    // For Workspace Expiry
    // For coupon buy staffMemberData?.banner_info?.coupon_id
    if (action === "reroute") {
      goToRoute(bannerData?.redirect_url);
      return;
    }

    // For Workspace Buy   !workspaceUpsellModal && storeData?.constants?.workspace_domain_upsell_expiry_time && !subscriptionDetails?.workspace_details
    if (action === "workspace-buy") {
      dispatch(
        getWorkspacePriceDetails({
          acc_count: 1,
          domain: subscriptionDetails?.domain?.entity_id,
          type: 5,
        }),
      );
      dispatch(saveworkspaceUpsellModal(!workspaceUpsellModal));
      return;
    }
  };

  if (bannerData?.feature_name === DLP_BANNER_UPSELL_FEATURE_TYPE.THEME) {
    return <ThemeUpsellBanner />;
  }

  return (
    <div
      onClick={onBannerClick}
      className={`pointer workspace-buy-banner w-100 flex justify-center items-center white ${classes.banner} ${classAnimation.workspaceBannerBgAnimate}`}
    >
      {!!bannerData?.left_icon && 
        <div
          dangerouslySetInnerHTML={{
            __html: bannerData?.left_icon || "",
          }}
          className="flex justify-center ds-mr6"
        />
      }
      <div
        className="flex justify-center items-center"
        dangerouslySetInnerHTML={{
          __html: bannerData?.text?.replace?.("#timer#", `${hour}:${minute}:${second}`) || "",
        }}
      />
      {
        <div>
          <button
            className="br-none bg-white black md-text14 br-8 ds-pv8 ds-ml12 ds-mr40 ds-pl8 ds-pr8 pointer"
            onClick={onBannerClick}
          >
            {bannerData?.button_text || (!expiryTime ? "Update Now" : "Get it now")}
          </button>
        </div>
      }
    </div>
  );
};

export default AppBanner;
